import { render, staticRenderFns } from "./GenreFields.vue?vue&type=template&id=249035f2"
import script from "./GenreFields.vue?vue&type=script&lang=js"
export * from "./GenreFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports